var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 0.599976C13.304 0.60144 12.6687 0.995972 12.3588 1.61902C11.3518 3.66095 9.62684 7.15393 9.02284 8.37897L1.56584 9.46094C0.876751 9.56134 0.304302 10.0441 0.0891228 10.7064C-0.126057 11.3687 0.0532951 12.0957 0.55183 12.5819L5.95182 17.8419C5.72084 19.1879 5.06282 23.0239 4.67881 25.2679C4.5616 25.9545 4.84321 26.6483 5.4058 27.059C5.96937 27.4672 6.71571 27.5207 7.33177 27.1969L14.0018 23.697L20.6718 27.197C21.2879 27.5207 22.0343 27.4672 22.5979 27.0589L22.5978 27.059C23.1597 26.6486 23.4412 25.9559 23.3248 25.2699C22.9398 23.0259 22.2818 19.188 22.0518 17.842L27.4518 12.582C27.9487 12.0951 28.128 11.3692 27.9148 10.707C27.6993 10.045 27.1268 9.56274 26.4378 9.46295L18.9808 8.38098C18.3808 7.15601 16.6518 3.66296 15.6448 1.62097C15.3349 0.99585 14.6975 0.600281 13.9998 0.599976ZM13.9998 2.81299L17.2228 9.34198C17.4899 9.8811 18.0045 10.2548 18.5998 10.342L25.7998 11.389L20.5888 16.4709C20.158 16.8913 19.961 17.4965 20.0618 18.09C20.2749 19.332 20.8978 22.96 21.2928 25.264L14.8498 21.877C14.3171 21.5996 13.6826 21.5996 13.1498 21.877L6.70582 25.264C7.10081 22.964 7.72383 19.3329 7.93583 18.09C8.03703 17.4965 7.83998 16.8912 7.40882 16.4709L2.19783 11.389L9.39784 10.342C9.99314 10.2548 10.5078 9.8811 10.7749 9.34198C11.3319 8.21198 12.9628 4.909 13.9978 2.81299H13.9998Z",
    fill: "url(#paint0_linear_0_1729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1729",
    x1: 14.0014,
    y1: 0.599976,
    x2: 14.0014,
    y2: 27.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.343eacc55ec7fe8e164ad8d672b76ac6.svg";
export { ForwardRef as ReactComponent };